import { __spreadArray } from "tslib";
import Keyframes from '../models/Keyframes';
import addUnitIfNeeded from './addUnitIfNeeded';
import { EMPTY_ARRAY } from './empties';
import getComponentName from './getComponentName';
import hyphenate from './hyphenateStyleName';
import isFunction from './isFunction';
import isPlainObject from './isPlainObject';
import isStatelessFunction from './isStatelessFunction';
import isStyledComponent from './isStyledComponent';
/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function (chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === '';
};
export var objToCssArray = function (obj) {
    var rules = [];
    for (var key in obj) {
        var val = obj[key];
        if (!obj.hasOwnProperty(key) || isFalsish(val))
            continue;
        // @ts-expect-error Property 'isCss' does not exist on type 'any[]'
        if ((Array.isArray(val) && val.isCss) || isFunction(val)) {
            rules.push("".concat(hyphenate(key), ":"), val, ';');
        }
        else if (isPlainObject(val)) {
            rules.push.apply(rules, __spreadArray(__spreadArray(["".concat(key, " {")], objToCssArray(val), false), ['}'], false));
        }
        else {
            rules.push("".concat(hyphenate(key), ": ").concat(addUnitIfNeeded(key, val), ";"));
        }
    }
    return rules;
};
export default function flatten(chunk, executionContext, styleSheet, stylisInstance) {
    if (isFalsish(chunk)) {
        return [];
    }
    /* Handle other components */
    if (isStyledComponent(chunk)) {
        return [".".concat(chunk.styledComponentId)];
    }
    /* Either execute or defer the function */
    if (isFunction(chunk)) {
        if (isStatelessFunction(chunk) && executionContext) {
            var result = chunk(executionContext);
            if (process.env.NODE_ENV !== 'production' &&
                typeof result === 'object' &&
                !Array.isArray(result) &&
                !(result instanceof Keyframes) &&
                !isPlainObject(result) &&
                result !== null) {
                console.error("".concat(getComponentName(chunk), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."));
            }
            return flatten(result, executionContext, styleSheet, stylisInstance);
        }
        else {
            return [chunk];
        }
    }
    if (chunk instanceof Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet, stylisInstance);
            return [chunk.getName(stylisInstance)];
        }
        else {
            return [chunk];
        }
    }
    /* Handle objects */
    if (isPlainObject(chunk)) {
        return objToCssArray(chunk);
    }
    if (!Array.isArray(chunk)) {
        return [chunk.toString()];
    }
    return flatMap(chunk, function (chunklet) {
        return flatten(chunklet, executionContext, styleSheet, stylisInstance);
    });
}
function flatMap(array, transform) {
    return Array.prototype.concat.apply(EMPTY_ARRAY, array.map(transform));
}
//# sourceMappingURL=flatten.js.map